import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import Header from '../../components/Header';
import Link from '../../components/Link';
import styles from '../styles/produtos/Produtos.module.css';
import ImageModal from 'react-modal';
import NotificacaoSucesso from '../../components/NotificacaoSucesso';
import NotificacaoErro from '../../components/NotificacaoErro';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import useEmpresas from '../../controllers/nomesEmpresas';
import useEmpresasTabelas from '../../controllers/empresasTabelas';
import Loading2 from '../../components/Loading2/Index';
import { MdAddShoppingCart } from "react-icons/md";
import { MdOutlineFormatAlignJustify } from "react-icons/md";

const opcoesProdutosPorPagina = [30, 60, 90, 120, 300];
const PRODUTOS_POR_PAGINA_KEY = 'produtos_por_pagina';

const obterProdutosPorPaginaSalvo = () => {
  const valorSalvo = Number(localStorage.getItem(PRODUTOS_POR_PAGINA_KEY));

  if (opcoesProdutosPorPagina.includes(valorSalvo)) {
    return valorSalvo;
  }

  return 30;
};

const formatarReal = (valor) => {
  if (valor === null || valor === undefined || valor === '') return '';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(Number(valor));
};

const capitalizarTexto = (texto) => {
  if (!texto) return '';

  return texto
    .toLowerCase()
    .split(' ')
    .map((palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1))
    .join(' ');
};

const Produtos = () => {
  const permissoes = JSON.parse(localStorage.getItem('permissoes'));

  const { empresas } = useEmpresas();

  const [isLoading, setIsLoading] = useState(false);

  const [produtos, setProdutos] = useState([]);
  const [classes, setClasses] = useState([]);
  const [fabricantes, setFabricantes] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [filtros, setFiltros] = useState({});
  const [pagina, setPagina] = useState(1);
  const [paginaDigitada, setPaginaDigitada] = useState('1');
  const [produtosPorPagina, setProdutosPorPagina] = useState(obterProdutosPorPaginaSalvo);
  const [totalProdutos, setTotalProdutos] = useState(0);
  const [totalQtd, setTotalQtd] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  const [codigo, setCodigo] = useState('');
  const [codigoBruto, setCodigoBruto] = useState('');
  const [descricao, setDescricao] = useState('');
  const [empresaSelecionada, setEmpresaSelecionada] = useState([]);
  const [linhaSelecionada, setLinhaSelecionada] = useState('');
  const [grupoSelecionado, setGrupoSelecionado] = useState([]);
  const [banhoSelecionado, setBanhoSelecionado] = useState([]);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState([]);
  const [classeSelecionada, setClasseSelecionada] = useState('');
  const [fabricanteSelecionado, setFabricanteSelecionado] = useState('');
  const [fornecedorSelecionado, setFornecedorSelecionado] = useState('');
  const [pesoInicial, setPesoInicial] = useState('');
  const [pesoFinal, setPesoFinal] = useState('');
  const [qtdInicial, setQtdInicial] = useState('');
  const [qtdFinal, setQtdFinal] = useState('');

  const tabelasPermitidas = permissoes?.produtos?.tabelas_preco_permitidas || [];
  const defaultTabela = tabelasPermitidas.length === 1 ? tabelasPermitidas[0] : '';
  const [tabelaPreco, setTabelaPreco] = useState(defaultTabela);
  const [precoInicial, setPrecoInicial] = useState('');
  const [precoFinal, setPrecoFinal] = useState('');
  const [removerDoFiltro, setRemoverDoFiltro] = useState([]);
  const [generico, setGenerico] = useState(false);
  const [naoGenerico, setNaoGenerico] = useState(false);
  const [ocultos, setOcultos] = useState(false);

  // Estado para controlar a visibilidade de "Remover da busca"
  const [removerDoFiltroVisivel, setRemoverDoFiltroVisivel] = useState(false);
  const toggleRemoverDoFiltro = () => {
    setRemoverDoFiltroVisivel(!removerDoFiltroVisivel);
  };

  // Estado para controlar a visibilidade do formulário no mobile
  const [formMobileVisivel, setFormMobileVisivel] = useState(false);

  const [quantidades, setQuantidades] = useState({});

  const [tabelasPorEmpresa, setTabelasPorEmpresa] = useState({});
  const [mostrarEmpresas, setMostrarEmpresas] = useState(false);

  const empresaTabela = useEmpresasTabelas();

  useEffect(() => {
    const tabelaPorEmpresa = empresaTabela.reduce((acc, empresa) => {
      acc[empresa.codigo] = empresa.tabela;
      return acc;
    }, {});
    setTabelasPorEmpresa(tabelaPorEmpresa);
  }, [empresaTabela]);

  // Manipulação de filtros visíveis/invisíveis para cada linha de produto
  const handleAlteracaoLinha = (event) => {
    setGrupoSelecionado([]);
    setBanhoSelecionado([]);
    setCategoriaSelecionada([]);
    setLinhaSelecionada(event.target.value);
  };

  // Mostrar/ocultar o formulário de filtros no mobile
  const alternarVisibilidadeFormMobile = () => {
    setFormMobileVisivel(prevState => !prevState);
  };

  // Requisição para o back-end
  const token = localStorage.getItem('token');
  const fetchProdutos = useCallback(async (filtrosAplicados = {}) => {
    setIsLoading(true);
    try {
      const { codigo, codigoBruto, descricao, empresa, linha, grupo, banho, categoria, classe, fabricante, fornecedor, pesoInicial, pesoFinal, qtdInicial, qtdFinal, tabela_preco, precoInicial, precoFinal, removerDoFiltro, generico, naoGenerico, ocultos } = filtrosAplicados;
      const response = await axios.get('https://provin.ind.br/api/produtos', {
        headers: { 'Authorization': `Bearer ${token}` },
        params: { codigo, codigoBruto, descricao, empresa, linha, grupo, banho, categoria, classe, fabricante, fornecedor, pesoInicial, pesoFinal, qtdInicial, qtdFinal, tabela_preco, precoInicial, precoFinal, removerDoFiltro, generico, naoGenerico, ocultos, permissoes: JSON.stringify(permissoes), pagina, limit: produtosPorPagina }
      });
      const { data } = response;
      const produtos = data.data;

      if (produtos && produtos.length > 0) {
        // Requisições para tabelas de preço
        const requests = produtos.map(produto =>
          axios.get('https://provin.ind.br/api/api/produtos/listaTabelasPreco', {
            headers: { 'Authorization': `Bearer ${token}` },
            params: { codigo: produto.codigo },
          }).then(response => ({
            codigo: produto.codigo,
            tabelasPreco: response.data, // Tabelas de preço retornadas
          }))
        );

        // Espera todas as requisições de tabelas de preço serem concluídas
        const tabelasPrecos = await Promise.all(requests);

        // Transforma o array tabelasPreco em um objeto indexado pela tabela
        const produtosComPrecos = produtos.map(produto => {
          const tabelas = (tabelasPrecos.find(item => item.codigo === produto.codigo)?.tabelasPreco || [])
            .reduce((acc, tabela) => {
              acc[tabela.tabela] = tabela.valor;
              return acc;
            }, {});

          return {
            ...produto,
            tabelas, // Adiciona o objeto tabelas ao produto
          };
        });

        // Atualiza o estado com os produtos e tabelas de preço
        setProdutos(produtosComPrecos);
      } else {
        // Caso não haja produtos, limpa o estado
        setProdutos([]);
      }

      setTotalProdutos(data.totalProdutos);
      setTotalQtd(data.totalQtd);
      setTotalPrice(data.totalPrice);
    } catch (error) {
      console.error('Erro ao buscar produtos', error);
    } finally {
      setIsLoading(false);
      document.getElementById('codigo')?.focus();
    }
  }, [pagina, produtosPorPagina]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchProdutos(filtros);
  }, [filtros, fetchProdutos]);

  // Buscar classes, fabricantes e fornecedores para os select's
  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const response = await axios.get('https://provin.ind.br/api/api/produtos/listaClasses', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        setClasses(response.data);
      } catch (error) {
        console.error('Erro ao buscar classes', error);
      }
    };

    const fetchFabricantes = async () => {
      try {
        const response = await axios.get('https://provin.ind.br/api/api/produtos/listaFabricantes', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        setFabricantes(response.data);
      } catch (error) {
        console.error('Erro ao buscar fabricantes', error);
      }
    };

    const fetchFornecedores = async () => {
      try {
        const response = await axios.get('https://provin.ind.br/api/api/produtos/listaFornecedores', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        setFornecedores(response.data);
      } catch (error) {
        console.error('Erro ao buscar fornecedores', error);
      }
    };

    fetchClasses();
    fetchFabricantes();
    fetchFornecedores();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Manter filtros de checkboxes marcados após submissão do formulário
  const handleAtivacaoCheckbox = (event, setState, state) => {
    const { value, checked } = event.target;
    if (checked) {
      setState([...state, value]);
    } else {
      setState(state.filter((item) => item !== value));
    }
  };

  const marcarTodasEmpresas = () => {
    setEmpresaSelecionada((permissoes.produtos.empresas_permitidas || []).map((codigo) => String(codigo)));
  };

  const limparEmpresasSelecionadas = () => {
    setEmpresaSelecionada([]);
  };

  // Remover da Busca
  const handleRemoverDoFiltroChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      // Adiciona o checkbox ao array
      setRemoverDoFiltro((prev) => [...prev, value]);
    } else {
      // Remove o checkbox do array
      setRemoverDoFiltro((prev) => prev.filter((item) => item !== value));
    }
  };

  const handleAtivacaoGenerico = () => {
    setGenerico((prev) => !prev);
  };

  const handleAtivacaoNaoGenerico = () => {
    setNaoGenerico((prev) => !prev);
  };

  const handleAtivacaoOcultos = () => {
    setOcultos((prev) => !prev);
  };

  // Submit do formulário
  const handleSubmit = (e) => {
    e.preventDefault();

    setMostrarEmpresas(false);

    // Armazena os filtros aplicados no estado
    const filtrosAplicados = {
      codigo,
      codigoBruto,
      descricao,
      empresa: empresaSelecionada,
      linha: linhaSelecionada,
      grupo: grupoSelecionado,
      banho: banhoSelecionado,
      categoria: categoriaSelecionada,
      classe: classeSelecionada,
      fabricante: fabricanteSelecionado,
      fornecedor: fornecedorSelecionado,
      pesoInicial,
      pesoFinal,
      qtdInicial,
      qtdFinal,
      tabela_preco: tabelaPreco,
      precoInicial,
      precoFinal,
      removerDoFiltro,
      generico,
      naoGenerico,
      ocultos
    };

    setFiltros(filtrosAplicados); // Armazena os filtros aplicados no estado
    setPagina(1); // Reinicia a paginação para a primeira página
    fetchProdutos(filtrosAplicados); // Busca os produtos com os filtros aplicados
    setFormMobileVisivel(false); // Oculta o formulário no mobile
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Rolagem para o topo da página
  };

  // Submit do formulário mobile (temporário para contagem das lojas)
  const handleSubmitLimpaFocaliza = (e) => {
    if (e.preventDefault) e.preventDefault();

    setMostrarEmpresas(false);

    // Armazena os filtros aplicados no estado
    const filtrosAplicados = {
      codigo,
      codigoBruto,
      descricao,
      empresa: empresaSelecionada,
      linha: linhaSelecionada,
      grupo: grupoSelecionado,
      banho: banhoSelecionado,
      categoria: categoriaSelecionada,
      classe: classeSelecionada,
      fabricante: fabricanteSelecionado,
      fornecedor: fornecedorSelecionado,
      pesoInicial,
      pesoFinal,
      qtdInicial,
      qtdFinal,
      tabela_preco: tabelaPreco,
      precoInicial,
      precoFinal,
      removerDoFiltro,
      generico,
      naoGenerico,
      ocultos
    };

    setQuantidades({});

    setFiltros(filtrosAplicados); // Armazena os filtros aplicados no estado
    setPagina(1); // Reinicia a paginação para a primeira página
    fetchProdutos(filtrosAplicados); // Busca os produtos com os filtros aplicados
    setFormMobileVisivel(false); // Oculta o formulário no mobile
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Rolagem para o topo da página

    setCodigo(''); // Limpa o campo do código (para não precisar ficar limpando manualmente a cada consulta, otimizando o tempo)

    document.getElementById('codigo_mobile')?.focus();
  };

  // Submit do formulário desktop (temporário para contagem das lojas)
  const handleSubmitLimpaFocalizaDesktop = (e) => {
    if (e.preventDefault) e.preventDefault();

    setMostrarEmpresas(false);

    // Armazena os filtros aplicados no estado
    const filtrosAplicados = {
      codigo,
      codigoBruto,
      descricao,
      empresa: empresaSelecionada,
      linha: linhaSelecionada,
      grupo: grupoSelecionado,
      banho: banhoSelecionado,
      categoria: categoriaSelecionada,
      classe: classeSelecionada,
      fabricante: fabricanteSelecionado,
      fornecedor: fornecedorSelecionado,
      pesoInicial,
      pesoFinal,
      qtdInicial,
      qtdFinal,
      tabela_preco: tabelaPreco,
      precoInicial,
      precoFinal,
      removerDoFiltro,
      generico,
      naoGenerico,
      ocultos
    };

    setQuantidades({});

    setFiltros(filtrosAplicados); // Armazena os filtros aplicados no estado
    setPagina(1); // Reinicia a paginação para a primeira página
    fetchProdutos(filtrosAplicados); // Busca os produtos com os filtros aplicados
    setFormMobileVisivel(false); // Oculta o formulário no mobile
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Rolagem para o topo da página

    setCodigo(''); // Limpa o campo do código (para não precisar ficar limpando manualmente a cada consulta, otimizando o tempo)

    document.getElementById('codigo')?.focus();
  };

  const handleToggleOculto = async (codigoProduto) => {
    try {
      const response = await axios.post('https://provin.ind.br/api/produtos/toggle-oculto', { codigo: codigoProduto }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.data.success) {
        setProdutos(prevProdutos =>
          prevProdutos.map(p =>
            p.codigo === codigoProduto ? { ...p, is_oculto: response.data.is_oculto } : p
          )
        );
      }
    } catch (error) {
      console.error('Erro ao alternar visibilidade do produto:', error);
      alert('Erro ao alterar o status do produto.');
    }
  };

  // Abrir a imagem do produto em um modal ampliado
  ImageModal.setAppElement('#root');
  const [modalAberto, setModalAberto] = useState(false);
  const [imagemSelecionada, setImagemSelecionada] = useState('');
  const abrirModal = (caminhoImagem) => {
    setImagemSelecionada(caminhoImagem);
    setModalAberto(true);
  };
  const fecharModal = () => {
    setModalAberto(false);
  };

  // Paginação dos produtos
  const totalPaginas = Math.ceil(totalProdutos / produtosPorPagina);

  const handleAlterarProdutosPorPagina = (event) => {
    const novoLimite = Number(event.target.value);
    localStorage.setItem(PRODUTOS_POR_PAGINA_KEY, String(novoLimite));
    setProdutosPorPagina(novoLimite);
    setPagina(1);
  };

  const irParaPagina = (proximaPagina) => {
    const paginaNumerica = Number(proximaPagina);

    if (!Number.isFinite(paginaNumerica) || totalPaginas < 1) {
      setPaginaDigitada(String(pagina));
      return;
    }

    const paginaNormalizada = Math.min(Math.max(Math.trunc(paginaNumerica), 1), totalPaginas);
    setPagina(paginaNormalizada);
    setPaginaDigitada(String(paginaNormalizada));
  };

  const voltarPagina = () => {
    irParaPagina(pagina - 1);
  };

  const avancarPagina = () => {
    irParaPagina(pagina + 1);
  };

  // Armazenar a quantidade inserida no input do produto
  const handleAlteracaoQuantidade = (codigo, valor) => {
    setQuantidades((prevQuantidades) => ({
      ...prevQuantidades,
      [codigo]: valor,
    }));
  };

  // Adicionar produto na sacola
  const [modalSucesso, setModalSucesso] = useState(false);
  const [modalErroSacola, setModalErroSacola] = useState(false);
  const [mensagemErroSacola, setMensagemErroSacola] = useState('');
  const adicionarSacola = async (codigo, descr_longa) => {
    const usuario = localStorage.getItem('usuario');
    const quantidade = Number(quantidades[codigo] || 1);
    const empresasAlvo = empresaSelecionada.map(Number).filter(Number.isFinite);

    if (!usuario) {
      alert("Usuário não está logado.");
      return;
    }

    if (empresasAlvo.length > 1) {
      alert("Selecione no máximo uma empresa no filtro para adicionar o produto na sacola.");
      return;
    }

    if (quantidade < 1) {
      alert("Quantidade inválida.");
      return;
    }

    try {
      await axios.post(
        'https://provin.ind.br/api/api/produtos/adicionarSacola',
        { usuario, codigo, descr_longa, quantidade, estoqueAlvo: empresasAlvo[0] ?? null },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setModalSucesso(true); // abre o modal
    } catch (error) {
      console.error('Erro ao adicionar o produto na sacola:', error);

      const dadosErro = error.response?.data;

      if (error.response?.status === 409 && dadosErro) {
        if (dadosErro.estoqueAlvo) {
          setMensagemErroSacola(
            // `${dadosErro.error} Empresa: ${dadosErro.estoqueAlvo}. Solicitado: ${dadosErro.quantidadeSolicitada}. Disponível: ${dadosErro.qtdDisponivelParaPedido} (estoque: ${dadosErro.estoqueAlvoQtd}, pedidos abertos: ${dadosErro.qtdPedidosAbertos}).`
            `Quantidade insuficiente para novo pedido. (estoque: ${dadosErro.estoqueAlvoQtd}, pedidos abertos: ${dadosErro.qtdPedidosAbertos})`
          );
        } else {
          setMensagemErroSacola(dadosErro.error || "Erro ao adicionar o produto na sacola!");
        }
      } else {
        setMensagemErroSacola("Erro ao adicionar o produto na sacola!");
      }

      setModalErroSacola(true);
      setTimeout(() => {
        setModalErroSacola(false);
      }, 5000);
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Rola suavemente para o topo
    });
  }, [pagina]);

  useEffect(() => {
    setPaginaDigitada(String(pagina));
  }, [pagina]);

  // Listagem de estoques
  const usuario = localStorage.getItem('usuario');
  const [mostrarEstoques, setMostrarEstoques] = useState(false);
  useEffect(() => {
    if (usuario === "revenda") {
      setMostrarEstoques(true);
    }
  }, [usuario]);
  const [estoquesByCodigo, setEstoquesByCodigo] = useState({}); // { codigo: [{empresa, qtd_em_terc, qtd_disponivel}] }
  const [loadingCodigos, setLoadingCodigos] = useState({});      // { codigo: boolean }
  const [erroCodigos, setErroCodigos] = useState({});

  const handleToggleEstoques = () => {
    setMostrarEstoques(prev => !prev);
  };

  const codigosUnicos = useMemo(
    () => Array.from(new Set(produtos.map(p => p.codigo))),
    [produtos]
  );

  useEffect(() => {
    if (!usuario || codigosUnicos.length === 0) return;

    const ac = new AbortController();

    const fetchCodigo = async (codigo) => {
      setLoadingCodigos(s => ({ ...s, [codigo]: true }));
      setErroCodigos(s => ({ ...s, [codigo]: undefined }));

      const params = new URLSearchParams({ usuario, codigo });
      const url = `https://provin.ind.br/api/api/produtos/listaEstoques?${params.toString()}`;

      try {
        const r = await fetch(url, { signal: ac.signal });
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        const json = await r.json();
        setEstoquesByCodigo(s => ({ ...s, [codigo]: json.data || [] }));
      } catch (e) {
        setErroCodigos(s => ({ ...s, [codigo]: "Falha ao consultar estoques" }));
        setEstoquesByCodigo(s => ({ ...s, [codigo]: [] }));
      } finally {
        setLoadingCodigos(s => ({ ...s, [codigo]: false }));
      }
    };

    // dispara todas em paralelo
    Promise.allSettled(codigosUnicos.map(fetchCodigo));

    return () => ac.abort();
  }, [usuario, codigosUnicos]);

  // Remover os Filtros e Submeter o Formulário
  const handleLimparSubmeter = (e) => {
    e.preventDefault();

    setMostrarEmpresas(false);

    setCodigo('');
    setCodigoBruto('');
    setDescricao('');
    setEmpresaSelecionada([]);
    setLinhaSelecionada('');
    setGrupoSelecionado([]);
    setBanhoSelecionado([]);
    setCategoriaSelecionada([]);
    setClasseSelecionada('');
    setFabricanteSelecionado('');
    setFornecedorSelecionado('');
    setPesoInicial('');
    setPesoFinal('');
    setQtdInicial('');
    setQtdFinal('');
    setTabelaPreco(tabelasPermitidas.length === 1 ? tabelasPermitidas[0] : '');
    setPrecoInicial('');
    setPrecoFinal('');
    setRemoverDoFiltro([]);
    setGenerico(false);
    setNaoGenerico(false);
    setOcultos(false);

    setFiltros({
      codigo: '',
      codigoBruto: '',
      descricao: '',
      empresa: [],
      linha: '',
      grupo: [],
      banho: [],
      categoria: [],
      classe: '',
      fabricante: '',
      fornecedor: '',
      pesoInicial: '',
      pesoFinal: '',
      qtdInicial: '',
      qtdFinal: '',
      tabela_preco: tabelasPermitidas.length === 1 ? tabelasPermitidas[0] : '',
      precoInicial: '',
      precoFinal: '',
      removerDoFiltro: [],
      generico: false,
      naoGenerico: false,
      ocultos: false
    });

    setQuantidades({});

    setPagina(1); // Reinicia a paginação para a primeira página
    fetchProdutos({}); // Busca os produtos sem filtros aplicados
    setFormMobileVisivel(false); // Oculta o formulário no mobile
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Rolagem para o topo da página
  };

  return (
    <div className={styles.body}>
      <Header />

      <Link redirectTo="/home" />

      {/* Filtro visível apenas em mobile */}
      <fieldset className={styles.mobile}>
        <p className={styles.formMobileTitle}>Filtros de pesquisa:</p>

        <div className={styles.formMobile}>
          <div className={styles.filtrosMobile}>
            <input type="text" id="codigo_mobile" value={codigo} placeholder="Código..." onChange={(e) => setCodigo(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { handleSubmitLimpaFocaliza({}); } }} />
            <input type="text" value={descricao} placeholder="Descrição..." onChange={(e) => setDescricao(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { handleSubmitLimpaFocaliza({}); } }} />
          </div>

          <button className={styles.abrirFiltrosMobile} onClick={alternarVisibilidadeFormMobile}><MdOutlineFormatAlignJustify /></button>
        </div>

        <div className={styles.botoesSubmitLimparMobile}>
          <button type="button" className={styles.cancelarForm} onClick={handleLimparSubmeter}>Limpar filtro</button>
          <button type="button" className={styles.submitForm} onClick={handleSubmitLimpaFocaliza}>Pesquisar</button>
        </div>
      </fieldset>

      {/* Totais */}
      <div className={styles.totais}>
        <p><span>{totalProdutos}</span> Modelos</p>
        {filtros.empresa && filtros.empresa.length > 0 && (<p><span>{totalQtd ? totalQtd : 0}</span> Peças</p>)}
        {filtros.empresa && filtros.empresa.length > 0 && (<p><span>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(totalPrice)}</span> Valor do Estoque (Atacado)</p>)}
      </div>

      <div className={styles.produtosPorPagina}>
        <label htmlFor="produtosPorPagina">Produtos por página</label>
        <select
          id="produtosPorPagina"
          value={produtosPorPagina}
          onChange={handleAlterarProdutosPorPagina}
          disabled={isLoading}
        >
          {opcoesProdutosPorPagina.map((opcao) => (
            <option key={opcao} value={opcao}>{opcao}</option>
          ))}
        </select>
      </div>

      <div className={styles.container}>
        {/* Formulário */}
        <form className={`${styles.form} ${formMobileVisivel ? styles.ativo : ''}`} id="form" onSubmit={handleSubmit}>
          <fieldset disabled={isLoading}>
            <div className={styles.atalhosForm}>
              <button type="button" className={styles.cancelarFormCompleto} onClick={handleLimparSubmeter}>Limpar filtro</button>
              <button type="button" className={styles.submitFormCompleto} onClick={handleSubmitLimpaFocalizaDesktop}>Pesquisar</button>
            </div>

            {/* Código */}
            <div className={styles.filtros}>
              <p>Código</p>
              <input type="text" id="codigo" value={codigo} onChange={(e) => setCodigo(e.target.value)} />
            </div>

            {/* Código Bruto */}
            {permissoes?.produtos?.filtro_codigoBruto && (
              <div className={styles.filtros}>
                <p>Código Bruto</p>
                <input type="text" id="codigoBruto" value={codigoBruto} onChange={(e) => setCodigoBruto(e.target.value)} />
              </div>
            )}

            {/* Descrição */}
            <div className={styles.filtros}>
              <p>Descrição</p>
              <input type="text" value={descricao} onChange={(e) => setDescricao(e.target.value)} />
            </div>

            {/* Empresa */}
            {permissoes.produtos.filtro_empresa && (
              <div className={styles.filtros}>
                <p>Empresa</p>
                <div className={styles.selectEmpresas} onClick={() => setMostrarEmpresas(!mostrarEmpresas)}>
                  <span>
                    {empresaSelecionada.length > 0
                      ? `${empresaSelecionada.length} ${empresaSelecionada.length === 1 ? 'selecionada' : 'selecionadas'}`
                      : 'Selecionar...'}
                  </span>
                  <i className={`fas fa-chevron-${mostrarEmpresas ? 'up' : 'down'}`}></i>
                </div>
                {mostrarEmpresas && (
                  <ul style={{ listStyleType: 'none', padding: 0, margin: 0, marginTop: '10px' }}>
                    <li className={styles.atalhosEmpresas}>
                      <button type="button" onClick={marcarTodasEmpresas}>
                        Marcar tudo
                      </button>
                      <button type="button" onClick={limparEmpresasSelecionadas}>
                        Limpar
                      </button>
                    </li>
                    {permissoes.produtos.empresas_permitidas.map((codigo, index) => (
                      <li key={index}>
                        <label className={styles.svgToggleSwitch}>
                          <input type="checkbox" value={String(codigo)} onChange={(e) => handleAtivacaoCheckbox(e, setEmpresaSelecionada, empresaSelecionada)} checked={empresaSelecionada.includes(String(codigo))} />
                          <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                            <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                            <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                          </svg>
                          {empresas[codigo] ? `${codigo} - ${capitalizarTexto(empresas[codigo])}` : codigo}
                        </label>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}

            {/* Estoque */}
            {permissoes.produtos.filtro_estoque && (
              <div className={styles.filtros}>
                <p>Qtd. Estoque</p>
                <div className={styles.filtroEstoque}>
                  <input type="number" min="0" value={qtdInicial} onChange={(e) => setQtdInicial(e.target.value)} placeholder="Mín" />
                  <input type="number" min="0" value={qtdFinal} onChange={(e) => setQtdFinal(e.target.value)} placeholder="Máx" />
                </div>
              </div>
            )}

            {/* Preço (Tabela) */}
            {tabelasPermitidas.length > 0 && (
              <div className={styles.filtros}>
                <p>Preço</p>
                {tabelasPermitidas.length > 1 && (
                  <select value={tabelaPreco} onChange={(e) => setTabelaPreco(e.target.value)} style={{ marginBottom: '10px' }}>
                    <option value="">Selecione a Tabela</option>
                    {tabelasPermitidas.map(tabela => (
                      <option key={tabela} value={tabela}>Tabela {tabela}</option>
                    ))}
                  </select>
                )}

                <div className={styles.filtroEstoque}>
                  <input type="number" min="0" step="0.01" value={precoInicial} onChange={(e) => setPrecoInicial(e.target.value)} placeholder="Mín" />
                  <input type="number" min="0" step="0.01" value={precoFinal} onChange={(e) => setPrecoFinal(e.target.value)} placeholder="Máx" />
                </div>
              </div>
            )}

            {/* Linha */}
            {(permissoes.produtos.filtro_linhaAcessorio || permissoes.produtos.filtro_linhaAco || permissoes.produtos.filtro_linhaAlmoxarifado || permissoes.produtos.filtro_linhaBanhada || permissoes.produtos.filtro_linhaBruto || permissoes.produtos.filtro_linhaOuro || permissoes.produtos.filtro_linhaPrata || permissoes.produtos.filtro_linhaRelogio) && (
              <div className={styles.filtros}>
                <p>Linha</p>
                <div className={styles.opcoes}>
                  <label className={`${styles.customRadio} ${linhaSelecionada === "" ? styles.checked : ""}`}><input type="radio" value="" checked={linhaSelecionada === ""} onChange={handleAlteracaoLinha} />Todas</label>
                  {permissoes.produtos.filtro_linhaBanhada && (<label className={`${styles.customRadio} ${linhaSelecionada === "banhada" ? styles.checked : ""}`}><input type="radio" value="banhada" checked={linhaSelecionada === "banhada"} onChange={handleAlteracaoLinha} />Banhadas</label>)}
                  {permissoes.produtos.filtro_linhaAco && (<label className={`${styles.customRadio} ${linhaSelecionada === "aco" ? styles.checked : ""}`}><input type="radio" value="aco" checked={linhaSelecionada === "aco"} onChange={handleAlteracaoLinha} />Aço</label>)}
                  {permissoes.produtos.filtro_linhaOuro && (<label className={`${styles.customRadio} ${linhaSelecionada === "ouro" ? styles.checked : ""}`}><input type="radio" value="ouro" checked={linhaSelecionada === "ouro"} onChange={handleAlteracaoLinha} />Ouro</label>)}
                  {permissoes.produtos.filtro_linhaPrata && (<label className={`${styles.customRadio} ${linhaSelecionada === "prata" ? styles.checked : ""}`}><input type="radio" value="prata" checked={linhaSelecionada === "prata"} onChange={handleAlteracaoLinha} />Prata</label>)}
                  {permissoes.produtos.filtro_linhaRelogio && (<label className={`${styles.customRadio} ${linhaSelecionada === "relogio" ? styles.checked : ""}`}><input type="radio" value="relogio" checked={linhaSelecionada === "relogio"} onChange={handleAlteracaoLinha} />Relógios</label>)}
                  {permissoes.produtos.filtro_linhaAcessorio && (<label className={`${styles.customRadio} ${linhaSelecionada === "acessorio" ? styles.checked : ""}`}><input type="radio" value="acessorio" checked={linhaSelecionada === "acessorio"} onChange={handleAlteracaoLinha} />Acessórios</label>)}
                  {permissoes.produtos.filtro_linhaAlmoxarifado && (<label className={`${styles.customRadio} ${linhaSelecionada === "almoxarifado" ? styles.checked : ""}`}><input type="radio" value="almoxarifado" checked={linhaSelecionada === "almoxarifado"} onChange={handleAlteracaoLinha} />Almoxarifado</label>)}
                  {permissoes.produtos.filtro_linhaBruto && (<label className={`${styles.customRadio} ${linhaSelecionada === "bruto" ? styles.checked : ""}`}><input type="radio" value="bruto" checked={linhaSelecionada === "bruto"} onChange={handleAlteracaoLinha} />Brutos</label>)}
                </div>
              </div>
            )}

            {/* Grupo */}
            {linhaSelecionada === 'acessorio' && (
              <div className={styles.filtros}>
                <p>Grupo</p>
                {[
                  { label: 'Bolsa', value: '1700' },
                  { label: 'Óculos', value: '1600' },
                  { label: 'Bomba', value: '1411' },
                  { label: 'Caneta', value: '1435' },
                  { label: 'Carteira', value: '1414' },
                  { label: 'Cuia', value: '1416' },
                  { label: 'Guarda-chuva', value: '1418' },
                  { label: 'Sombrinha', value: '1444' },
                  { label: 'Lenço', value: '1419' },
                  { label: 'Luva', value: '1420' },
                  { label: 'Maleta', value: '1421' },
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setGrupoSelecionado, grupoSelecionado)} checked={grupoSelecionado.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}
            {linhaSelecionada === 'aco' && (
              <div className={styles.filtros}>
                <p>Grupo</p>
                {[
                  { label: 'Aliança', value: '1356' },
                  { label: 'Anel', value: '1351' },
                  { label: 'Brinco', value: '1355' },
                  { label: 'Choker', value: '1357' },
                  { label: 'Conjunto', value: '1365' },
                  { label: 'Gargantilha', value: '1352' },
                  { label: 'Pingente', value: '1353' },
                  { label: 'Pulseira', value: '1354' },
                  { label: 'Tornozeleira', value: '1364' }
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setGrupoSelecionado, grupoSelecionado)} checked={grupoSelecionado.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}
            {(linhaSelecionada === 'banhada' || linhaSelecionada === 'bruto') && (
              <div className={styles.filtros}>
                <p>Grupo</p>
                {[
                  { label: 'Anel', value: '1111' },
                  { label: 'Brinco', value: '1112' },
                  { label: 'Choker', value: '1117' },
                  { label: 'Conjunto', value: '1113' },
                  { label: 'Gargantilha', value: '1114' },
                  { label: 'Piercing', value: '1118' },
                  { label: 'Pingente', value: '1115' },
                  { label: 'Pulseira', value: '1116' },
                  { label: 'Tornozeleira', value: '1119' }
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setGrupoSelecionado, grupoSelecionado)} checked={grupoSelecionado.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}
            {linhaSelecionada === 'ouro' && (
              <div className={styles.filtros}>
                <p>Grupo</p>
                {[
                  { label: 'Aliança', value: '1317' },
                  { label: 'Anel', value: '1311' },
                  { label: 'Brinco', value: '1312' },
                  { label: 'Choker', value: '1361' },
                  { label: 'Conjunto', value: '1313' },
                  { label: 'Fecho', value: '1319' },
                  { label: 'Gargantilha', value: '1314' },
                  { label: 'Pingente', value: '1315' },
                  { label: 'Pulseira', value: '1316' },
                  { label: 'Tarraxa', value: '1318' },
                  { label: 'Tornozeleira', value: '1373' }
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setGrupoSelecionado, grupoSelecionado)} checked={grupoSelecionado.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}
            {linhaSelecionada === 'prata' && (
              <div className={styles.filtros}>
                <p>Grupo</p>
                {[
                  { label: 'Aliança', value: '1331' },
                  { label: 'Anel', value: '1332' },
                  { label: 'Brinco', value: '1333' },
                  { label: 'Choker', value: '1342' },
                  { label: 'Conjunto', value: '1337' },
                  { label: 'Gargantilha', value: '1335' },
                  { label: 'Piercing', value: '1340' },
                  { label: 'Pingente', value: '1334' },
                  { label: 'Pulseira', value: '1336' },
                  { label: 'Tornozeleira', value: '1343' }
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setGrupoSelecionado, grupoSelecionado)} checked={grupoSelecionado.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}

            {/* Banho */}
            {linhaSelecionada === 'banhada' && (
              <div className={styles.filtros}>
                <p>Banho</p>
                {[
                  { label: 'Ouro', value: '% AU%' },
                  { label: 'Ródio Branco', value: '% RB%' },
                  { label: 'Ródio Negro', value: '% RN%' },
                  { label: 'Prata Leve', value: '% PL%' },
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setBanhoSelecionado, banhoSelecionado)} checked={banhoSelecionado.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}

            {/* Categoria */}
            {linhaSelecionada === 'almoxarifado' && (
              <div className={styles.filtros}>
                <p>Categoria</p>
                {[
                  { label: 'Caixas de Veludo', value: 'CAIXAS DE VELUDO' },
                  { label: 'Embalagens', value: 'EMBALAGEM' },
                  { label: 'Reposição', value: 'REPOSIÇÃO' },
                  { label: 'Pacotes de Presente', value: 'PACOTES DE PRESENTE' },
                  { label: 'Pacotes Adesivos', value: 'PACOTES TRANSPARENTES ADESIVOS' },
                  { label: 'Zip Lock', value: 'PACOTES TRANSPARENTES COM ZÍPER' },
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setCategoriaSelecionada, categoriaSelecionada)} checked={categoriaSelecionada.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}
            {(linhaSelecionada === 'aco' || linhaSelecionada === 'banhada' || linhaSelecionada === 'prata') && (
              <div className={styles.filtros}>
                <p>Categoria</p>
                {[
                  { label: 'Cristal', value: 'CR %' },
                  { label: 'Lisa', value: 'LIS %' },
                  { label: 'Madrepérola', value: 'MP %' },
                  { label: 'Pedra', value: 'PD %' },
                  { label: 'Pérola', value: 'PÉR %' },
                  { label: 'Zircônia', value: 'ZR %' },
                  { label: 'Correntaria', value: 'CORR %' },
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setCategoriaSelecionada, categoriaSelecionada)} checked={categoriaSelecionada.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}
            {linhaSelecionada === 'bruto' && (
              <div className={styles.filtros}>
                <p>Categoria</p>
                {[
                  { label: 'Cristal', value: 'CRISTAL' },
                  { label: 'Lisa', value: 'LISA' },
                  { label: 'Madrepérola', value: 'MADREPÉROLA' },
                  { label: 'Pedra', value: 'PEDRA' },
                  { label: 'Pérola', value: 'PÉROLA' },
                  { label: 'Zircônia', value: 'ZIRCÔNIA' },
                  { label: 'Correntaria', value: 'CORRENTE' },
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setCategoriaSelecionada, categoriaSelecionada)} checked={categoriaSelecionada.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}
            {linhaSelecionada === 'ouro' && (
              <div className={styles.filtros}>
                <p>Categoria</p>
                {[
                  { label: 'Baixo', value: 'BX OP%' },
                  { label: '18k', value: '18 OP%' },
                  { label: '18k c/ Bts', value: '18BTS OP%' },
                ].map((item) => (
                  <label key={item.value} className={styles.svgToggleSwitch}>
                    <input type="checkbox" value={item.value} onChange={(e) => handleAtivacaoCheckbox(e, setCategoriaSelecionada, categoriaSelecionada)} checked={categoriaSelecionada.includes(item.value)} />
                    <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                      <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                      <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                    </svg>
                    {item.label}
                  </label>
                ))}
              </div>
            )}

            {/* Classe */}
            {permissoes.produtos.filtro_classe && (
              <div className={styles.filtros}>
                <p>Classe</p>
                <select value={classeSelecionada} onChange={(e) => setClasseSelecionada(e.target.value)}>
                  <option value="">Todas</option>
                  {classes.map((classe) => (
                    <option key={classe} value={classe}>{classe}</option>
                  ))}
                </select>
              </div>
            )}

            {/* Fabricante */}
            {permissoes.produtos.filtro_fabricante && (
              <div className={styles.filtros}>
                <p>Fabricante</p>
                <select value={fabricanteSelecionado} onChange={(e) => setFabricanteSelecionado(e.target.value)}>
                  <option value="">Todos</option>
                  {fabricantes.map((fabricante) => (
                    <option key={fabricante} value={fabricante}>{fabricante}</option>
                  ))}
                </select>
              </div>
            )}

            {/* Fornecedor */}
            {permissoes.produtos.filtro_fornecedor && (
              <div className={styles.filtros}>
                <p>Fornecedor</p>
                <select value={fornecedorSelecionado} onChange={(e) => setFornecedorSelecionado(e.target.value)}>
                  <option value="">Todos</option>
                  {fornecedores.map((fornecedor) => (
                    <option key={fornecedor} value={fornecedor}>{fornecedor}</option>
                  ))}
                </select>
              </div>
            )}

            {/* Peso */}
            {permissoes.produtos.filtro_peso && (
              <div className={styles.filtros}>
                <p>Peso (g)</p>
                <div className={styles.filtroPesos}>
                  <input type="number" min="0" value={pesoInicial} onChange={(e) => setPesoInicial(e.target.value)} placeholder='Min' />
                  <input type="number" min="0" value={pesoFinal} onChange={(e) => setPesoFinal(e.target.value)} placeholder='Max' />
                </div>
              </div>
            )}

            <br />
            <hr />
            <br />

            {/* Genérico */}
            {permissoes.produtos.filtro_genericos && (
              <div className={styles.checkboxLeft}>
                <label className={styles.svgToggleSwitch} style={{ display: 'flex', justifyContent: 'center' }}>
                  <input type="checkbox" checked={generico} onChange={handleAtivacaoGenerico} />
                  <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                    <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                    <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                  </svg>
                  Genéricos
                </label>
              </div>
            )}

            {/* Genérico */}
            {permissoes.produtos.filtro_naoGenericos && (
              <div className={styles.checkboxLeft}>
                <label className={styles.svgToggleSwitch} style={{ display: 'flex', justifyContent: 'center' }}>
                  <input type="checkbox" checked={naoGenerico} onChange={handleAtivacaoNaoGenerico} />
                  <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                    <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                    <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                  </svg>
                  Não Genéricos
                </label>
              </div>
            )}

            {/* Exibir estoques */}
            {permissoes.produtos.info_estoques && (
              <div className={styles.checkboxLeft}>
                <label className={styles.svgToggleSwitch} style={{ display: 'flex', justifyContent: 'center' }}>
                  <input type="checkbox" checked={mostrarEstoques} onChange={handleToggleEstoques} />
                  <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                    <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                    <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                  </svg>
                  Estoques
                </label>
              </div>
            )}

            {/* Produtos Ocultos */}
            {permissoes.produtos.ocultar_exibir_produtos && (
              <div className={styles.checkboxLeft}>
                <label className={styles.svgToggleSwitch} style={{ display: 'flex', justifyContent: 'center' }}>
                  <input type="checkbox" checked={ocultos} onChange={handleAtivacaoOcultos} />
                  <svg className={styles.switchSvg} viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" >
                    <rect x="5" y="5" width="90" height="40" rx="20" className={styles.switchBackground} />
                    <circle cx="30" cy="25" r="18" className={styles.switchCircle} />
                  </svg>
                  Produtos Ocultos
                </label>
              </div>
            )}

            {/* Remover do Filtro */}
            {permissoes.produtos.filtro_removerDoFiltro && (
              <div className={styles.toggleRemoverDoFiltro}>
                <button type="button" onClick={toggleRemoverDoFiltro} data-tip="Dica do botão">{removerDoFiltroVisivel ? 'Fechar' : 'Remover da Busca'}</button>
                <i className="fa-solid fa-circle-info" id="toggleRemoverDoFiltro"></i>
                <Tooltip
                  anchorSelect="#toggleRemoverDoFiltro"
                  content={
                    "Use essa função para remover produtos da busca!\n(Facilita a procura por produtos sem características\n relevantes)"
                  }
                  style={{ whiteSpace: 'pre-line' }}
                />
              </div>
            )}

            {removerDoFiltroVisivel && (
              <div className={styles.filtros}>
                <p style={{ textAlign: "center", color: "#696969", fontSize: "14px" }}>Remover da Busca</p>
                <label><input type="checkbox" className={styles.checkboxRemoverDoFiltro} value="Argol" onChange={handleRemoverDoFiltroChange} checked={removerDoFiltro.includes("Argol")} />Argola</label><br />
                <label><input type="checkbox" className={styles.checkboxRemoverDoFiltro} value="Coração" onChange={handleRemoverDoFiltroChange} checked={removerDoFiltro.includes("Coração")} />Coração</label><br />
                <label><input type="checkbox" className={styles.checkboxRemoverDoFiltro} value="Infinito" onChange={handleRemoverDoFiltroChange} checked={removerDoFiltro.includes("Infinito")} />Infinito</label><br />
                <label><input type="checkbox" className={styles.checkboxRemoverDoFiltro} value="Ponto de Luz" onChange={handleRemoverDoFiltroChange} checked={removerDoFiltro.includes("Ponto de Luz")} />Ponto de Luz</label><br />
                <label><input type="checkbox" className={styles.checkboxRemoverDoFiltro} value="Solitário" onChange={handleRemoverDoFiltroChange} checked={removerDoFiltro.includes("Solitário")} />Solitário</label>
              </div>
            )}

            <button type="submit" onClick={handleSubmitLimpaFocalizaDesktop}>Pesquisar</button>
          </fieldset>
        </form>

        {/* Container dos produtos */}
        {isLoading ? (
          <div style={{ margin: "0 auto" }}>
            <Loading2 message={"Carregando produtos..."} />
          </div>
        ) : (
          <div className={styles.containerProdutos}>
            {produtos.map((produto) => {
              const codigo = produto.codigo;
              const linhas = estoquesByCodigo[codigo] || [];
              const produtoBruto = (produto.descr_longa || '').toUpperCase().includes('BRUTO');

              return (
                <div key={codigo} className={styles.cardProduto}>
                  <div className={styles.cardMedia}>
                    <img
                      src={`https://provin.ind.br/api/imagem_produto/${codigo.replace(/\//g, '+')}`}
                      alt=""
                      onClick={() =>
                        abrirModal(`https://provin.ind.br/api/imagem_produto/${codigo.replace(/\//g, '+')}`)
                      }
                    />
                  </div>

                  <div className={styles.cardConteudo}>
                    <div className={styles.cardCabecalho}>
                      <div className={styles.codigoComSelo}>
                        <p className={styles.codigo}>{produto.codigo}</p>
                        {produtoBruto && (
                          <img
                            className={styles.iconeBruto}
                            src="/images/common/bruto.png"
                            alt="Produto bruto"
                            title="Produto bruto"
                          />
                        )}
                      </div>

                      {(permissoes?.produtos?.info_categoria || permissoes?.produtos?.info_classe) && (
                        <div className={styles.categoriaClasse}>
                          {permissoes?.produtos?.info_categoria &&
                            produto?.categoria && (
                              <p className={styles.categoria}>
                                {produto.categoria}
                              </p>
                            )}

                          {permissoes?.produtos?.info_categoria &&
                            produto?.categoria &&
                            permissoes?.produtos?.info_classe &&
                            produto?.especificacao && (
                              <span> / </span>
                            )}

                          {permissoes?.produtos?.info_classe &&
                            produto?.especificacao && (
                              <p className={styles.especificacao}>
                                {produto.especificacao}
                              </p>
                            )}
                        </div>
                      )}
                    </div>

                    {permissoes.produtos.info_aplicacao && (<p className={styles.aplicacao}>{produto.aplicacao && produto.aplicacao !== '.' ? produto.aplicacao.replace(/,/g, ', ') : ''}</p>)}

                    <p className={styles.descr_longa}>{produto.descr_longa}</p>

                    <div className={styles.infoLinha}>
                      {(permissoes.produtos.info_fabricante || permissoes.produtos.info_fornecedor || permissoes.produtos.info_refForn) && (
                        <p className={styles.fabricanteFornecedor}>
                          {permissoes.produtos.info_fabricante && produto.nome_fabricante}
                          {permissoes.produtos.info_fabricante && permissoes.produtos.info_fornecedor && produto.fantasia && ' / '}
                          {permissoes.produtos.info_fornecedor && produto.fantasia}
                          {permissoes.produtos.info_refForn && produto.cod_itemforn && produto.cod_itemforn !== '.' && (
                            <> ({produto.cod_itemforn})</>
                          )}
                        </p>
                      )}
                    </div>

                    <div className={styles.infoLinha}>
                      {permissoes.produtos.info_peso && (
                        <p className={styles.peso}>{produto.peso_liquido}kg</p>
                      )}

                      {permissoes.produtos.info_fcon1 && (
                        <p className={styles.fcon1}>Fcon1: {(produto.fator_conv_cod_barras || '').replace('.', ',')}</p>
                      )}

                      {permissoes.produtos.info_fcon2 && (
                        <p className={styles.fcon2}>Fcon2: {(produto.fator_conv_cod_barras_display || '').replace('.', ',')}</p>
                      )}
                    </div>
                  </div>

                  {/* Preços de tabelas */}
                  <div className={styles.tabelasPreco}>
                    {permissoes.produtos.tabelas_preco_permitidas.includes("10") && produto.tabelas[10] && (
                      <div>
                        {permissoes.produtos.info_labelTabela && <p>10</p>}
                        <span>{formatarReal(produto.tabelas[10])}</span>
                      </div>
                    )}

                    {permissoes.produtos.tabelas_preco_permitidas.includes("6") && produto.tabelas[6] && (
                      <div>
                        {permissoes.produtos.info_labelTabela && <p>6</p>}
                        <span>{formatarReal(produto.tabelas[6])}</span>
                      </div>
                    )}

                    {permissoes.produtos.tabelas_preco_permitidas.includes("7") && produto.tabelas[7] && (
                      <div>
                        {permissoes.produtos.info_labelTabela && <p>7</p>}
                        <span>{formatarReal(produto.tabelas[7])}</span>
                      </div>
                    )}

                    {permissoes.produtos.tabelas_preco_permitidas.includes("3") && produto.tabelas[3] && (
                      <div>
                        {permissoes.produtos.info_labelTabela && <p>S¹</p>}
                        <span>{formatarReal(produto.tabelas[3])}</span>
                      </div>
                    )}

                    {permissoes.produtos.tabelas_preco_permitidas.includes("12") && produto.tabelas[12] && (
                      <div>
                        {permissoes.produtos.info_labelTabela && <p>S²</p>}
                        <span>{formatarReal(produto.tabelas[12])}</span>
                      </div>
                    )}
                  </div>

                  {/* Preço principal (cada empresa tem o seu) */}
                  <div className={styles.price_label}>
                    {permissoes.produtos.info_valor && (
                      <>
                        {produto.tabelas[tabelasPorEmpresa[empresaSelecionada]] ? (
                          <span className={styles.price_label}>
                            {formatarReal(produto.tabelas[tabelasPorEmpresa[empresaSelecionada]])}
                          </span>
                        ) : produto.tabelas[tabelasPorEmpresa[10]] ? (
                          <span className={styles.price_label}>
                            {formatarReal(produto.tabelas[tabelasPorEmpresa[10]])}
                          </span>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>

                  {/* Estoques por empresa */}
                  {mostrarEstoques && permissoes.produtos.info_estoques && (
                    <div className={styles.estoquesBox}>
                      {linhas.map((row) => (
                        <div key={row.empresa} className={styles.estoqueItem}>
                          <b style={{ color: "#A020F0" }}>{row.empresa}</b><br />
                          Disp: {row.qtd_disponivel} / Terc: {row.qtd_em_terc}
                        </div>
                      ))}
                    </div>
                  )}

                  <div className={styles.funcoesProduto}>
                    <div className={styles.detalhes} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {/* {permissoes.produtos.info_detalhes && (
                        <button>
                          <i className="fa-solid fa-circle-info" style={{ color: "#74c0fc" }}></i>
                        </button>
                      )} */}

                      {(permissoes.produtos.ocultar_exibir_produtos === true || permissoes.produtos.ocultar_exibir_produtos === "true") && (
                        <button
                          className={`${styles.bolinhaVisibilidade} ${produto.is_oculto ? styles.bolinhaVermelha : styles.bolinhaVerde}`}
                          onClick={() => handleToggleOculto(produto.codigo)}
                          title={produto.is_oculto ? 'Oculto (clique para exibir)' : 'Visível (clique para ocultar)'}
                        />
                      )}
                    </div>

                    {permissoes.produtos.info_addSacola && (
                      <div className={styles.sacola}>
                        {permissoes.produtos.info_inputQtdSacola && (
                          <input
                            type="number"
                            min="1"
                            value={quantidades[produto.codigo] || 1}
                            onChange={(e) =>
                              handleAlteracaoQuantidade(produto.codigo, e.target.value)
                            }
                          />
                        )}
                        <button onClick={() => adicionarSacola(produto.codigo, produto.descr_longa)}>
                          <MdAddShoppingCart />
                          <span>Adicionar na sacola</span>
                        </button>
                      </div>
                    )}
                  </div>

                  {Array.isArray(filtros.empresa) && filtros.empresa.length > 0 && produto.qtd_disponivel !== null && (
                    <p className={styles.qtd_em_estoque}>{produto.qtd_disponivel} em estoque</p>
                  )}
                </div>
              )
            })}
          </div>
        )}

        <NotificacaoSucesso
          show={modalSucesso}
          message="Produto adicionado com sucesso"
          onClose={() => setModalSucesso(false)}
        />

        <NotificacaoErro
          show={modalErroSacola}
          message={mensagemErroSacola}
          onClose={() => setModalErroSacola(false)}
        />

        <ImageModal
          isOpen={modalAberto}
          onRequestClose={fecharModal}
          contentLabel="Imagem Ampliada"
          className={styles.modalImagem}
          style={{
            overlay: { backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 9999 },
            content: {
              inset: 0,              // ocupa a tela inteira
              padding: 0,
              background: 'transparent',
              border: 'none',
              overflow: 'hidden',
            },
          }}
        >
          <div
            onClick={fecharModal}
            style={{
              width: '100vw',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              padding: '24px',
              boxSizing: 'border-box',
            }}
          >
            <img
              src={imagemSelecionada}
              alt="Imagem ampliada"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                cursor: 'pointer',
                userSelect: 'none',
              }}
              draggable={false}
              onClick={(e) => {
                e.stopPropagation(); // evita fechar ao clicar na imagem (se quiser)
              }}
            />
          </div>
        </ImageModal>
      </div>

      {/* Controles de Paginação */}
      <div className={styles.paginacao}>
        {totalPaginas > 0 && (
          <button
            type="button"
            onClick={() => irParaPagina(1)}
            disabled={pagina === 1}
            className={pagina === 1 ? styles.ativa : ''}
          >
            1
          </button>
        )}

        {totalPaginas > 1 && (
          <button
            type="button"
            onClick={voltarPagina}
            disabled={pagina === 1}
            aria-label="Página anterior"
            title="Página anterior"
          >
            {'<'}
          </button>
        )}

        {totalPaginas > 0 && (
          <input
            type="number"
            min="1"
            max={totalPaginas}
            value={paginaDigitada}
            onChange={(e) => setPaginaDigitada(e.target.value)}
            onBlur={() => irParaPagina(paginaDigitada)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.currentTarget.blur();
              }
            }}
            aria-label="Ir para página"
            title="Ir para página"
          />
        )}

        {totalPaginas > 1 && (
          <button
            type="button"
            onClick={avancarPagina}
            disabled={pagina === totalPaginas}
            aria-label="Próxima página"
            title="Próxima página"
          >
            {'>'}
          </button>
        )}

        {totalPaginas > 1 && (
          <button
            type="button"
            onClick={() => irParaPagina(totalPaginas)}
            disabled={pagina === totalPaginas}
            className={pagina === totalPaginas ? styles.ativa : ''}
          >
            {totalPaginas}
          </button>
        )}
      </div>
    </div >
  );
}

export default Produtos;
